import React, { useEffect, useState } from 'react';

const BlockDevTools = () => {
  const [isDevToolsBlocked, setIsDevToolsBlocked] = useState(true); // Default is blocking DevTools

  useEffect(() => {
    let devtools = { open: false };
    const threshold = 160; // Height threshold when DevTools is open

    // Function to detect if DevTools is open by checking window size
    function detectDevTools() {
      const width =
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold;
      if (width) {
        devtools.open = true;
      } else {
        devtools.open = false;
      }
    }

    // Check every 500ms if DevTools is open
    const intervalId = setInterval(detectDevTools, 500);

    // Disable right-click
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    let lastF12Time = 0;

    const handleKeyDown = (event) => {
      const currentTime = new Date().getTime();

      // Handle other blocked shortcuts
      if (
        event.key === 'F12' ||
        (event.ctrlKey && event.shiftKey && event.key === 'I') ||
        (event.ctrlKey && event.key === 'U') ||
        (event.ctrlKey && event.key === 'k') // Block Ctrl+K only when isDevToolsBlocked is true
      ) {
        if (isDevToolsBlocked) {
          event.preventDefault();
          window.location.reload();
        }
      }

      // Toggle DevTools block feature with Ctrl+K
      if (event.ctrlKey && event.key === 'k') {
        setIsDevToolsBlocked((prevState) => !prevState); // Toggle the state
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup function when component is unmounted
    return () => {
      clearInterval(intervalId);
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isDevToolsBlocked]); // Dependency array: effect reruns when isDevToolsBlocked changes

  return null; // This component does not render anything
};

export default BlockDevTools;
